export default __webpack_public_path__ + "static/landing_bg-8fa22088b71582c2c25154ace9c0b2a5.jpg";